<template>
  <div class="changePwd">
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="旧密码">
        <el-input v-model="form.oldPwd" placeholder="输入旧密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="form.newPwd" placeholder="输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码">
        <el-input
          v-model="form.againNewPwd"
          placeholder="再次输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item size="large">
        <el-button type="primary" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { changePwd } from "@/api/platform";
export default {
  data () {
    return {
      form: {
        oldPwd: '',
        newPwd: '',
        againNewPwd: "",
      }
    }
  },
  components: {},
  created () { },
  computed: {},
  mounted () { },
  methods: {
    async confirm () {
      const { oldPwd, newPwd, againNewPwd } = this.form
      if (!oldPwd) return this.$api.msg('请输入旧密码');
      if (!newPwd) return this.$api.msg('请输入新密码');
      if (!againNewPwd) return this.$api.msg('请再次输入新密码');
      if (newPwd !== againNewPwd) return this.$api.msg('两次密码输入不正确');
      await changePwd({
        oldpassword: oldPwd,
        password: newPwd,
      })
      return this.$notify.success({
        title: '提示',
        message: '修改成功'
      });
    }
  },
}
</script>
<style lang='less' scoped>
.el-form {
  width: 350px;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/ChangePwd.vue